/**
 * ConfirmacaoCadastralSection — toggle "Confirmação cadastral automática",
 * extraído do `AiTab` interno de `ConfigTenantPage.tsx:157-219` (Admin Hub T8).
 *
 * Item 363 F3 — degrau 2 do detector de alteração cadastral (P12 opt-in,
 * default OFF). Salva IMEDIATO no clique (`update.mutate`, sem dirty-diff) —
 * contrato mantido tal e qual: NÃO se registra na `StickySaveBar` (não há
 * "sujo" para agregar; a mutação já aconteceu quando o usuário vê o novo
 * estado do switch).
 *
 * O `AiTab` original também tinha um `<h2>Configuração de IA</h2>` + um
 * `<Link to="/admin/ai-config">Abrir configuração de IA →</Link>` — ambos
 * MORREM aqui, não só ficam de fora da extração:
 *   - o header falava da tela antiga inteira (que este componente não é
 *     mais — ele é só o toggle);
 *   - o link levava para uma rota que agora, ela mesma, redireciona para
 *     `/admin/ia#modelos` (T3) — ou seja, de volta para a MESMA página onde
 *     este componente passa a viver. "Modelos" é âncora nesta página
 *     (`#modelos`, seção `ModelosSection`), não link para outro lugar.
 */

import { useTenantConfig, useUpdateTenantConfig } from './use-tenant-config';

export function ConfirmacaoCadastralSection({
  canManage,
}: {
  readonly canManage: boolean;
}): JSX.Element {
  const query = useTenantConfig();
  const update = useUpdateTenantConfig();
  const autoConfirm = query.data?.autoConfirmCadastralChange ?? false;
  const disabled = !canManage || update.isPending || query.isLoading;

  return (
    <div className="max-w-2xl">
      <h3 className="mb-2 text-sm font-semibold text-text-primary">Proatividade</h3>
      <div className="flex items-center justify-between rounded-xl border border-border-subtle bg-surface p-4">
        <div className="pr-4">
          <h4 className="text-sm font-medium text-text-primary">
            Confirmação cadastral automática
          </h4>
          <p className="mt-0.5 text-xs text-text-secondary">
            Quando a IA detecta um pedido de alteração de dados cadastrais vindo de um canal
            não-validado e já existe uma coleta de dados em andamento na conversa, a verificação com
            o titular é enviada automaticamente (sem esperar o clique do atendente). Sem coleta em
            andamento, o sistema apenas sinaliza no painel.
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={autoConfirm}
          aria-label="Confirmação cadastral automática"
          disabled={disabled}
          onClick={() => {
            update.mutate({ autoConfirmCadastralChange: !autoConfirm });
          }}
          className={`relative h-5 w-9 flex-shrink-0 rounded-full transition-colors disabled:opacity-50 ${
            autoConfirm ? 'bg-accent' : 'bg-border-subtle'
          }`}
        >
          <span
            className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform ${
              autoConfirm ? 'translate-x-[18px]' : 'translate-x-0.5'
            }`}
          />
        </button>
      </div>
      {update.isError && (
        <p className="mt-2 text-xs text-red-600">Não foi possível salvar. Tente novamente.</p>
      )}
    </div>
  );
}
